import Auth from '@/components/Auth.vue';
import FormComponent from '@/components/FormComponent.vue';
import FormModal from '@/components/FormModal.vue';
import TaskStatus from '@/components/TaskStatus';
import UiNavbar from '@/components/UiNavbar.vue';
import UiNavbarPanel from '@/components/UiNavbarPanel';
import UiUpload from '@/components/UiUpload';
import UiFileIcon from '@/components/UiFilePreview';
import UiFiles from '@/components/UiFiles';
import UiSimpleFiles from '@/components/UiSimpleFiles';
import TaskMessages from '@/components/TaskMessages';
import UserName from '@/components/UserName';
import UiLabel from '@/components/UiLabel';
import SelectTaskStatus from '@/components/SelectTaskStatus';
import SelectLabel from '@/components/SelectLabel';
import SelectPlatform from '@/components/SelectPlatform';
import PlatformLabel from '@/components/PlatformLabel';
import PlatformInfo from '@/components/PlatformInfo';
import PlatformPriorityIcon from '@/components/PlatformPriorityIcon';
import SelectExecutor from '@/components/SelectExecutor';

export default {
  Auth,
  FormComponent,
  FormModal,
  TaskStatus,
  UiNavbar,
  UiNavbarPanel,
  UiUpload,
  UiFileIcon,
  UiFiles,
  UiSimpleFiles,
  TaskMessages,
  UserName,
  UiLabel,
  SelectTaskStatus,
  SelectLabel,
  SelectPlatform,
  PlatformLabel,
  PlatformInfo,
  PlatformPriorityIcon,
  SelectExecutor,
};
